import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SecretClass;
function Secret() {
  if (SecretClass === VOID) {
    class $ {
      constructor(id, description, createdTimestamp, lastUsedTimestamp) {
        this.l2f_1 = id;
        this.m2f_1 = description;
        this.n2f_1 = createdTimestamp;
        this.o2f_1 = lastUsedTimestamp;
      }
      toString() {
        return 'Secret(id=' + this.l2f_1.toString() + ', description=' + this.m2f_1 + ', createdTimestamp=' + this.n2f_1.toString() + ', lastUsedTimestamp=' + toString(this.o2f_1) + ')';
      }
      hashCode() {
        var result = this.l2f_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.m2f_1) | 0;
        result = imul(result, 31) + this.n2f_1.hashCode() | 0;
        result = imul(result, 31) + (this.o2f_1 == null ? 0 : this.o2f_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Secret()))
          return false;
        if (!this.l2f_1.equals(other.l2f_1))
          return false;
        if (!(this.m2f_1 === other.m2f_1))
          return false;
        if (!this.n2f_1.equals(other.n2f_1))
          return false;
        if (!equals(this.o2f_1, other.o2f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Secret');
    SecretClass = $;
  }
  return SecretClass;
}
//region block: exports
export {
  Secret as Secret2t4auo9luo6wh,
};
//endregion

//# sourceMappingURL=Secret.mjs.map
